import router from './router'
import {delCookie, getCookie, getDeptId, setDeptId, setDeptName,getDeptName} from './utils/auth'
import {checkToken, getDept} from './api/index'

const whiteList = ['/home', '/category','/my', '/empower', '/invite', '/editInfo', '/yqEditInfo', '/success', '/login','/wxcode', '/share', '/ptcats', '/fxmsDetails', '/fxSpuDetails','/fxplusDetails', '/qkk','/empsq','/sqcg'];
const ss = ['/empsq','/sqcg'];

router.beforeEach(async (to, from, next) => {
    if(ss.includes(to.name)){
        document.title = to.meta.title;
    }else {
        if (getDeptName()){
            document.title=getDeptName()
        }else {
            document.title="商城"
        }
    }
    if (to.params.did && to.params.did != 'undefined') {
        if (getDeptId()) {
            if (getDeptId() != to.params.did) {
                setDeptId(to.params.did)
                delCookie("spmToken")
            }
        } else {
            setDeptId(to.params.did)
        }
        var _token = getCookie('spmToken')
        if (to.params.did){
            checkToken(_token,to.params.did).then(res => {
                if (!res.isLogin){
                    delCookie("spmToken")
                }
                setDeptName(res.deptName)
            }).catch(res => {
                delCookie("spmToken")
            });
        }
        let arr = to.path.split('/')
        let path = '/' + arr[1]
        if (_token) {
            // 已登录且要跳转的页面是登录页
            if (path === '/empower') {
                next({path: '/home/' + getDeptId()})
            } else {
                next()
            }
        } else {
            if (whiteList.indexOf(path) !== -1) { // 在免登录白名单，直接进入
                next()
            } else {
                getDept(getDeptId()).then(res => {
                    if (res && res.hloginType == 3) {
                        next('/login/' + getDeptId() + '/' + res.deptName) // 否则全部重定向到登录页
                    } else {
                        next('/empower/' + getDeptId()) // 否则全部重定向到登录页
                    }
                }).catch(res => {
                    next('/empower/' + getDeptId()) // 否则全部重定向到登录页
                });
            }
        }
    } else {
        if (to.path == '/404') {
            next()
        } else {
            next({path: '/404'})
        }
    }
})